import { ref } from 'vue';

/**
 * Filter state for VulnFeedTable.
 *
 * Stores filterSearchValue tokens and the result of parseFilters.
 */
export function useFilters({
    parseFilters = null,
} = {}) {
    const filterSearchValue = ref([]);
    /** Raw return value of parseFilters(data) */
    const parsedResult = ref(null);
    /** The token array from the search bar, for URL storage */
    const rawFilters = ref([]);

    /**
     * Called when the filtered search bar emits a submit event.
     * Runs parseFilters and stores the raw result.
     */
    function submit(data) {
        if (!Array.isArray(data)) {
            data = [];
        }
        filterSearchValue.value = data;
        rawFilters.value = data;

        let parser = parseFilters;
        let result = null;

        if (parser) {
            try {
                result = parser(data);
            } catch (e) {
                // If the custom parser fails, store null and let fetchFn handle it
                result = null;
            }
        }

        parsedResult.value = result;
        return result;
    }

    /**
     * Programmatically set filterSearchValue (e.g., restoring from URL).
     * Also parses the data.
     */
    function setFilterSearchValue(v) {
        filterSearchValue.value = v;
        rawFilters.value = Array.isArray(v) ? v : [];
        // Re-parse the new value
        if (parseFilters && Array.isArray(v)) {
            try {
                parsedResult.value = parseFilters(v);
            } catch (e) {
                parsedResult.value = null;
            }
        }
    }

    return {
        filterSearchValue,
        parsedResult,
        rawFilters,
        submit,
        setFilterSearchValue,
    };
}
